function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M896 1024a16 16 0 0 1-14.32-8.848l-64-128A16 16 0 0 1 816 880V48c0-26.464 21.536-48 48-48h64c26.464 0 48 21.536 48 48v832a16 16 0 0 1-1.68 7.152l-64 128A16 16 0 0 1 896 1024z m-48-147.776l48 96 48-96V48c0-8.816-7.168-16-16-16h-64c-8.832 0-16 7.184-16 16v828.224z",
  fill: "#e18891",
  "p-id": 2808
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M960 112h-128a16 16 0 1 1 0-32h128a16 16 0 1 1 0 32zM960 896h-128a16 16 0 1 1 0-32h128a16 16 0 1 1 0 32zM896 336a16 16 0 0 1-16-16V160a16 16 0 1 1 32 0v160a16 16 0 0 1-16 16zM736 1024H64a16 16 0 0 1-16-16V16a16 16 0 0 1 16-16h672a16 16 0 0 1 16 16v992a16 16 0 0 1-16 16zM80 992h640V32H80v960z",
  fill: "#e18891",
  "p-id": 2809
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M320 128H160a16 16 0 1 1 0-32h160a16 16 0 1 1 0 32zM640 192H160a16 16 0 1 1 0-32h480a16 16 0 1 1 0 32zM640 256H160a16 16 0 1 1 0-32h480a16 16 0 1 1 0 32zM640 320H160a16 16 0 1 1 0-32h480a16 16 0 1 1 0 32zM640 384H160a16 16 0 1 1 0-32h480a16 16 0 1 1 0 32zM640 448H160a16 16 0 1 1 0-32h480a16 16 0 1 1 0 32zM640 512H160a16 16 0 1 1 0-32h480a16 16 0 1 1 0 32zM640 576H160a16 16 0 1 1 0-32h480a16 16 0 1 1 0 32zM640 640H160a16 16 0 1 1 0-32h480a16 16 0 1 1 0 32z",
  fill: "#e18891",
  "p-id": 2810
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M640 704H160a16 16 0 1 1 0-32h480a16 16 0 1 1 0 32z",
  fill: "#e18891",
  "p-id": 2811
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M640 768H480a16 16 0 1 1 0-32h160a16 16 0 1 1 0 32z",
  fill: "#e18891",
  "p-id": 2812
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M197.44 928c-1.088 0-2.192-0.064-3.296-0.192-11.76-1.376-20.576-9.12-26.24-23.04l-22.72-55.84a16 16 0 1 1 29.632-12.048l22.72 55.824 0.432 1.008a20.8 20.8 0 0 0 0.848-1.712c3.552-8.16 6.32-16.544 8.288-25.056a104.192 104.192 0 0 1 3.2-56.144 15.984 15.984 0 1 1 31.008 3.12c1.424 10.992 1.76 22.096 1.008 33.168 4.576 1.792 8.16 5.616 9.536 10.496 1.92 6.608 3.488 11.488 6.608 14.144a9.76 9.76 0 0 0 5.2 1.76c0-0.64-0.032-1.52-0.16-2.704a96.304 96.304 0 0 0-2.96-15.44c-5.856-9.152-8.912-18.784-11.648-27.408a16 16 0 0 1 29.088-12.88 135.36 135.36 0 0 1 11.68 26.032c2.928 3.552 6.656 6.24 10.624 7.744a15.968 15.968 0 0 1 20.768-11.84c7.424 2.512 12.848 8.56 14.464 16.176 1.632 7.76-0.992 15.936-6.88 21.328-8.72 8-20.48 8.08-26.688 7.408a51.008 51.008 0 0 1-6.96-1.248 28.96 28.96 0 0 1-10.048 17.696c-13.92 11.552-35.296 7.84-47.168-2.208a46.544 46.544 0 0 1-2.912-2.72 14.944 14.944 0 0 1-2.592 1.024 168.96 168.96 0 0 1-4.112 10.32C221.792 919.36 210.24 928 197.44 928z",
  fill: "#e18891",
  "p-id": 2813
});

var SvgContractIcon = function SvgContractIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1625418079584,
    className: "icon",
    viewBox: "0 0 1024 1024",
    "p-id": 2807,
    width: 200,
    height: 200,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContractIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ContractIcon.859eee38.svg";
export { ForwardRef as ReactComponent };